export default {
  '&NameSplitter.No': 'No',
  '&NameSplitter.QuestionStart': '¿Tu %name es',
  '&NameSplitter.QuestionEnd': '?',
  '&NameSplitter.Yes': 'Sí',
} as TextDictionary;
